import { createContext, useMemo } from 'react';
import { useTheme } from '@deephaven/components';
import defaultChartTheme from "./ChartTheme.js";
import { jsx as _jsx } from "react/jsx-runtime";
export var ChartThemeContext = /*#__PURE__*/createContext(null);
ChartThemeContext.displayName = 'ChartThemeContext';
/*
 * Provides a chart theme based on the active themes from the ThemeProvider.
 */
export function ChartThemeProvider(_ref) {
  var children = _ref.children;
  var _useTheme = useTheme(),
    activeThemes = _useTheme.activeThemes;
  var chartTheme = useMemo(defaultChartTheme, [activeThemes]);
  return /*#__PURE__*/_jsx(ChartThemeContext.Provider, {
    value: chartTheme,
    children: children
  });
}
//# sourceMappingURL=ChartThemeProvider.js.map